import { I } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { ApiService } from 'app/lib/api.service';
import { LogService } from 'app/lib/log.service';
import { ModalService } from 'app/lib/modal.service';
import { Assessment } from 'app/models/assessment';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { Subject } from 'rxjs';
@Component({
    selector: 'app-assessment-view',
    templateUrl: './assessment-view.component.html',
    styleUrls: ['./assessment-view.component.scss'],
    standalone: false
})
export class AssessmentViewComponent implements OnInit {
    isLoaded = false;
    assessmentList = [];
    offset: number = 0;
    assessmentId: number;
    private getAssessmentDetails$ = new Subject<void>();
    constructor(
        private translate: TranslateService,
        private formBuilder: FormBuilder,
        private api: ApiService,
        private log: LogService,
        private modalService: ModalService,
        private activatedRoute: ActivatedRoute
    ) {
        this.activatedRoute.params.subscribe((params: Params) => {
            this.assessmentId = parseInt(params['id'], 10);
        });
    }

    ngOnInit(): void {
        this.isLoaded = true;

        this.getAssessmentDetails$
        .pipe(debounceTime(500))
        .subscribe(() => this.fetchAssessmentDetails());
        this.getAssessmentDetails();
        this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
            this.assessmentList = [];
            this.getAssessmentDetails();
        });
    }

    // Assessment Details API
    getAssessmentDetails() {
        this.getAssessmentDetails$.next();
    }
    private fetchAssessmentDetails() {
        this.api
            .get('form/surveyresults/' + this.assessmentId, {
                Limit: 10,
                Offset: this.assessmentList.length,
            })
            .subscribe(
                (result: any) => {
                    this.isLoaded = false;

                    if (result.length > 0) {
                        result.forEach(item => {
                            item.answerMap = new Map(
                                item.Questions.map(q => [q.QuestionID, q])
                            );
                        });
                        this.assessmentList =
                            this.assessmentList.concat(result);
                    }
                },
                (error: any) => {
                    this.log.error(
                        'Error getting assessment. ' + error.message
                    );
                    this.isLoaded = false;
                }
            );
    }

    LoadMore() {
        this.getAssessmentDetails();
    }

    getAnswerText(headerQuestionId: any, answerData: any) {
        const answer = answerData.answerMap.get(headerQuestionId);
        if (!answer) return '-';
        return [5, 6, 7, 8].includes(answer.QuestionType)
            ? answer.AnswerValue
            : answer.OptionComment;
    }
}
